var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPointer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 403.172 403.172",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M201.586,0c-85.468,0-155,69.532-155,155c0,51.179,24.938,96.635,63.294,124.878l80.073,117.154 c2.625,3.843,6.979,6.14,11.633,6.14c4.654,0,9.007-2.297,11.633-6.14l80.073-117.154 c38.356-28.243,63.294-73.699,63.294-124.878C356.586,69.532,287.054,0,201.586,0z M219.273,261.572 c-5.724,0.672-11.641,1.058-17.688,1.058s-11.965-0.386-17.688-1.056c-51.183-8.467-90.343-53.03-90.343-106.574 c0-59.568,48.462-108.03,108.03-108.03c59.568,0,108.03,48.462,108.03,108.03C309.616,208.544,270.457,253.107,219.273,261.572z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.586,
    cy: 155,
    r: 56.364
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPointer);
export default __webpack_public_path__ + "static/media/location-pointer.39cdbacf0f2a401f54811e83f3aa965c.svg";
export { ForwardRef as ReactComponent };